import React from 'react';
import { NavLink as Link } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, UncontrolledDropdown } from 'reactstrap';

const NavMenuPublic = (props) => {
    let { navMenu } = props;

    return (
        <Nav className="mr-auto nav" navbar>
            {navMenu.map((navItem, i) => {
                if (Object.keys(navItem.childNavItems).length > 0) {
                    return (
                        <UncontrolledDropdown key={i} nav inNavbar>
                            <DropdownToggle nav caret className="text-dark">
                                {navItem.title}
                            </DropdownToggle>
                            <DropdownMenu right>
                                {navItem.childNavItems.map((childNavItem, j) => {
                                    return (
                                        <span key={j}>
                                            {childNavItem.includeDivider &&
                                                <DropdownItem divider />
                                            }
                                            {childNavItem.openInNewTab &&
                                                <a href={childNavItem.routing} className="text-dark dropdown-item" target="_blank" rel="noopener noreferrer">{childNavItem.title}</a>
                                            }
                                            {!childNavItem.openInNewTab && childNavItem.externalLink &&
                                                <a href={childNavItem.externalLink} className="text-dark dropdown-item" target="_blank" rel="noopener noreferrer">{childNavItem.title}</a>
                                            }
                                            {!childNavItem.openInNewTab && childNavItem.routing &&
                                                <DropdownItem tag={Link} activeClassName="active" className="text-dark" to={childNavItem.routing} target="_self">{childNavItem.title}</DropdownItem>
                                            }
                                        </span>
                                    )
                                })}
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )
                } else {
                    return (
                        <NavItem key={i}>
                            <NavLink tag={Link} activeClassName="active" className={navItem.class} to={{ pathname: navItem.routing }} target={(navItem.openInNewTab ? "_blank" : "_self")} rel={(navItem.openInNewTab ? "noopener noreferrer" : "")}>{navItem.title}</NavLink>
                        </NavItem>
                    )
                }
            })}
        </Nav>
    );
}

export default NavMenuPublic;